// Load static fonts
require('typeface-merriweather')

exports.onInitialClientRender = require('./src/gatsby/browser/onInitialClientRender')
exports.onRouteUpdate = require('./src/gatsby/browser/onRouteUpdate')
exports.shouldUpdateScroll = require('./src/gatsby/browser/shouldUpdateScroll.js')
exports.wrapPageElement = require('./src/gatsby/browser/wrapPageElement.js').default
